<template>
    <div class="footer" :class="isCollapse?'collapse':''">
        <div class="download-container">
            <div v-if="!isCollapse">
                <img class="logo" src="../../../assets/images/img_logo_foot.png" alt="">
            </div>
            <div class="download-detail">
                <div class="download-detail-logo">
                    <img src="../../../assets/images/img_icon_foot.png" alt="">
                </div>
                <div class="download-list">
                    <div>{{ $router.lang.get('正式名稱：The Finder：追尋者') }}</div>
                    <div>{{ $router.lang.get('價格：免費含付費') }}</div>
                    <div>{{ $router.lang.get('項目類型：MMORPG') }}</div>
                    <div>{{ $router.lang.get('動作環境：iOS/Android') }}</div>
                </div>
                <div>
                        <!-- <div>
                            <a target="_blank" :href="iosLink">
                                <img class="is-butt" src="../../../assets/images/btn_ios_float.png" alt="">
                            </a>
                        </div> -->
                        <div>
                            <a target="_blank" :href="googleLink">
                                <img class="is-butt" src="../../../assets/images/btn_google_float.png" alt="">
                            </a>
                        </div>
                </div>
                <div class="facebook" v-if="isCollapse">
                    <a :href="facebookLink">
                        <img src="../../../assets/images/btn_facebook_foot.png" alt="">
                    </a>
                </div>
            </div>
        </div>
        <div class="real">
            <div class="copyright" :class="isCollapse?'copyright-collapse':''">
                <div class="_12-plus" v-if="!isCollapse">
                <div>
                    <img
                    class="icon-12-plus"
                    src="../../../assets/images/img_rating_12.jpg"
                    />
                </div>
                <div>
                    <div>
                    {{ $router.lang.get("本遊戲依據遊戲軟體分級管理辦法分類為輔12級。" ) }}<br v-if="isCollapse"/>{{ $router.lang.get("您需年滿12歲始得使用本遊戲。" ) }}
                    </div>
                    <div>
                    {{ $router.lang.get("本遊戲部分內容需要另支付費用。" ) }}<br v-if="isCollapse"/>{{ $router.lang.get("請註意遊戲時間，切勿沉迷或不當模仿。") }}
                    </div>
                </div>
                </div>
                <div>
                    <img
                    class="supergenes-logo"
                    src="../../../assets/images/img_logo_pangsky.png"
                    />
                    <span>Copyright © Supergenes Corp. All rights reserved.</span>
                </div>
            </div>
            <div class="facebook" v-if="!isCollapse">
                <a :href="facebookLink" target="_blank">
                    <img src="../../../assets/images/btn_facebook_foot.png" alt="">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { useScreenState } from "../../../store";
import browser from "../../../utils/browser"
import message from "../../../utils/message";

export default {
  name: "AppFooter",
  data() {
    return {
        googleLink: 'https://play.google.com/store/apps/details?id=com.pangsky.thfinder.google',
        iosLink: 'https://apps.apple.com/us/app/%EB%8D%94-%ED%8C%8C%EC%9D%B8%EB%8D%94/id1530492779',
        facebookLink: "https://www.facebook.com/The-Finder-%E0%B9%80%E0%B8%AA%E0%B9%89%E0%B8%99%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B9%80%E0%B8%AB%E0%B8%A5%E0%B9%88%E0%B8%B2%E0%B8%9C%E0%B8%B9%E0%B9%89%E0%B8%81%E0%B8%A5%E0%B9%89%E0%B8%B2-105971541717029/",
        myCardLink: browser.isIOS?"#":"https://cdn-thefinder.panggame.com/mycard/thefindertw_mycard.apk",
        isIOS: browser.isIOS,
        screenState: useScreenState(),
    };
  },
  methods: {
    checkUA () {
        if (this.isIOS) {
            message.showMessage(this, 'MyCard-APK僅支持Android運行。')
        }
    },
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
    isHome () {
      return this.isCollapse || this.$route.path == '/home'
    },
  },
};
</script>

<style scoped>

.download-list {
    height: 110px;
    display: flex;
    flex-direction: column;
}
.collapse .download-list {
    height: 12.67vw;
    font-size: 2vw;
}

.download-list > div {
    margin: auto 0;
}

.download-detail {
    display: flex;
    margin-left: auto;
    margin-top: 20px;
    width: 550px;
}

.download-detail > div{
    margin: auto;
}

.download-detail-logo > img {
    width: 110px;
}

.collapse .download-detail-logo > img {
    width: 12.67vw;
}


.logo {
    max-width: 374px;
    width: 31.17vw;
}

.download-container {
    display: flex;
    max-width: 1400px;
    width: 90vw;
}

.footer {
    background-size: 100% 100%;
    background-image: url(../../../assets/images/bg_img_foot.png);
    max-width: 1920px;
    width: 100vw;
    height: 400px;
    font-size: 14px;
  font-weight: 300;
  display: flex;
  flex-direction: column;
  margin: auto;
}

.collapse {
    background-image: url(../../../assets/images/bg_mobile_img_foot.png);
    height: 63.33vw;
    font-size: 1.4vw;
}

.collapse .is-butt {
width: 22.67vw;
}
.collapse .download-detail {
    margin-right: auto;
    width: 100vw;
    height: 18vw;
    margin-top: 0;
}

.not-home {
    background-repeat: no-repeat;
    background-size: 100% auto;
}

.footer > div {
  margin: auto;
}

.footer > .contact {
  color: #cccccc;
  padding-top: 179px;
  text-align: center;
}

.footer > ._12-plus {
  margin-top: 46px;
  display: flex;
  max-width: 582px;
}

.footer > ._12-plus-collapse {
  margin-top: 20px;
  flex-direction: column;
  font-size: calc(0.2vw + 12.2px);
}

.footer > ._12-plus-collapse div {
  width: 100%;
  text-align: center;
}

.footer > ._12-plus-collapse img {
  margin-bottom: 6px;
}

.footer > .copyright > div {
  margin-top: 13px;
}

.collapse > .copyright > div {
  margin-top: 1vw;
}

.copyright a {
  color: #aaaaaa;
  text-decoration: none;
}

.copyright a:hover {
  color: #cccccc;
  text-decoration: underline;
}

.copyright {
    display: flex;
    flex-direction: column;
}

.copyright > div {
    margin-top: auto;
    margin-bottom: auto;
}

.icon-12-plus {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  margin-bottom: -7px;
}

@media screen and (max-width: 900px) {
  .icon-12-plus {
    width: 6vw;
    height: 6vw;
    margin-top: 1.5vw;
  }
}

.pangsky-logo {
  width: 116px;
  height: 21px;
  margin-right: 1.25vw;
  margin-bottom: -3px;
}
.supergenes-logo {
  width: 147px;
  height: 20px;
  margin-right: 1.25vw;
  margin-bottom: -7px;
}

.collapse .supergenes-logo {
  width: 19.6vw;
  height: 2.667vw;
  margin-bottom: -0.1vw;
}

._12-plus {
    display: flex;
}

.real {
    display: flex;
}

.facebook {
    padding-left: 35px;
    margin-left: 40px;
    border-left: 1px solid #7F7E7E;
}

.collapse .facebook {
    padding-left: 3.73vw;
    margin-left: 4.33vw;
    height: 13.33vw;
}

.collapse .facebook img{
    height: 13.33vw;
}

</style>
